import { launchedLocales, nextLocale } from "../helpers/locales.mjs";

/**
 * TODO: this is from when we were running two CMS systems and shared templates,
 * the URL structures of both sites were different.
 *
 * We can probably remove this helper entirely at some point.
 */

export const getFaqHomeUrl = (currentLocale: string, route: string): string => {
  const matchedLocale =
    currentLocale === "ne-xt"
      ? nextLocale
      : launchedLocales.find((locale) => locale.localeString === currentLocale);

  if (!matchedLocale) {
    throw new Error(`Could not find a locale matching ${currentLocale}`);
  }

  const energydrinkSegment = "energydrink";

  // Find the position of the keyword in the URL
  const energydrinkSegmentIndex = route.indexOf(energydrinkSegment);

  // If the keyword is not found, return the original URL
  if (energydrinkSegmentIndex === -1) {
    return route;
  }

  // Extract the part of the URL after the keyword
  const remainingUrl = route.substring(
    energydrinkSegmentIndex + energydrinkSegment.length,
  );

  // Remove the forward slash if it exists at the start of the remaining URL
  const formattedRemainingUrl = remainingUrl.startsWith("/")
    ? remainingUrl.substring(1)
    : remainingUrl;

  const segments = formattedRemainingUrl.split("/");

  /**
   * Storyblok Return
   * /ne-xt/energydrink/questions/
   */
  if (
    segments[0] === "questions" ||
    segments[0] === "questions-next" ||
    segments[0] === "products" ||
    segments[0] === "products-next"
  ) {
    return `/${matchedLocale.localeString}/${energydrinkSegment}/questions`;
  }

  /**
   * Conteful Return:
   * /ne-xt/energydrink/{from-locales}
   */
  return `/${matchedLocale.localeString}/${energydrinkSegment}/${matchedLocale.faqSegment}`;
};
